export function initBurgerMenu() {
  const burgerWrappers = document.querySelectorAll('.po-header__burger-wrapper');
  const menu = document.querySelector('.po-menu');

  if (!menu || !burgerWrappers.length) return;

  burgerWrappers.forEach((burgerWrapper) => {
    burgerWrapper.addEventListener('click', () => {
      const isMenuOpen = menu.classList.toggle('po-menu__active');

      if (isMenuOpen) {
        document.body.classList.add('menu-open');

      } else {
        document.body.classList.remove('menu-open');
      }

      burgerWrappers.forEach((wrapper) => {
        const icon = wrapper.querySelector('use');
        icon.setAttribute(
            'href',
            isMenuOpen ? '#svg-icons-cross' : '#svg-icons-burger'
        );
      });
    });
  });
}
